var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-permission"},[_c('div',{staticClass:"no-permission-img"}),_vm._v(" "),_c('p',{staticClass:"no-permission-text"},[_vm._v("当前账号无权限")]),_vm._v(" "),_c('p',{staticClass:"no-permission-link"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }